import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=07754f21&scoped=true&"
import script from "./SelectType.vue?vue&type=script&lang=js&"
export * from "./SelectType.vue?vue&type=script&lang=js&"
import style0 from "./SelectType.vue?vue&type=style&index=0&id=07754f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07754f21",
  null
  
)

export default component.exports